import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'app-info-banner',
  imports: [CommonModule, MatIconModule],
  templateUrl: './info-banner.component.html',
  styleUrls: ['./info-banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InfoBannerComponent {
  @Input() type: 'warning' | 'error' = 'warning';
}
